import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'ad-img-viewer',
  templateUrl: './ad-img-viewer.component.html',
  styleUrls: ['./ad-img-viewer.component.scss']
})
export class AdImgViewerComponent implements OnInit {
  _items: { img: string, width: number, height: number }[];
  @Input() set items(val) {
    this._items = val;
    if (this.itemWidth && this.items && this.items.length > 0) {
      let img = this.items[0], conetntWidth = this.mainContent.nativeElement.getBoundingClientRect().width;
      console.log(conetntWidth);
      if (conetntWidth < img.width) {
        this.itemWidth = conetntWidth - 20;
      } else {
        this.itemWidth = img.width - 20;
      }
    }
  }

  get items() {
    return this._items;
  }
  @Input() itemWidth: number = 500;
  @Input() viewportHight: string = "100%";
  @Input() bufferAmount: number = 4;
  @Input() documentId: number;
  @Input() zoom = 1;
  @ViewChild("main", { static: true }) mainContent: ElementRef<HTMLDivElement>;
  @Input() itemGetter: (id: number) => Observable<{ img: string, width: number, height: number }[]>;
  loading = true;
  constructor() { }

  ngOnInit(): void {
    this.itemGetter(this.documentId).subscribe(items => {
      this.items = items;
      this.loading = false
    })
  }

  public zoomIn() {
    if (this.zoom <= 3) {
      this.zoom += 0.1;
    }
  }

  public zoomOut() {
    if (this.zoom > 0.5) {
      this.zoom -= 0.1;
    }
  }

  public doPrint(items){
    let printContents = "", popupWin;
    //printContents = this.mainContent.nativeElement.innerHTML;
    items.forEach(item => {
      printContents += `<div><img src="${item.img}" style="width:${item.width}px;height:${item.height}px"/></div>`;
    })
    popupWin = window.open('http://' + window.location.host + window.location.pathname, '_blank');
    setTimeout(() => {

      popupWin.document.write(`
<html>
  <head>
    <title></title>
    <style></style>
    <script>
      function printFun(){
        window.print();
        setTimeout(function(){
          //window.close();
        },10)
      }
    </script>
  </head>
<body onload="printFun();">
  <div>${printContents}</div>
</body>
</html>`
      );
      popupWin.document.close();
    }, 10)
    this.loading = false
  }

  public print() {
    return this.itemGetter(this.documentId);

  }

}
